module.exports = __webpack_public_path__ + "static/s4-3-taxes-d-2440fe8a5d7ec8244c1e281a1163f972.jpg";